/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
export const ROLES = {
  admin: 'admin',
  administratorSection: 'administrator_section',
  areaSection: 'area_section',
  storeSection: 'store_section',
  staffingContractor: 'staffing_contractor',
  regularContractor: 'regular_contractor',
  corpSite: 'corp_site',
};

export const SCOPES = {
  canViewStaffingContractorDashboardPage: 'can-view-staffing-contractor-dashboard-page',
  canViewAreaSectionDashboardPage: 'can-view-area-section-dashboard-page',
  canCreateJobs: 'can-create-jobs',
  canRegisterVehicles: 'can-register-vehicles',
  canEditVehicles: 'can-edit-vehicles',
  canRestoreVehicles: 'can-restore-vehicles',
  canDeleteVehicles: 'can-delete-vehicles',
  canViewCorpSiteDashboardPage: 'can-view-corp-site-dashboard-page',
  canViewAccountPage: 'can-view-account-page',
  canViewSettingsPage: 'can-view-settings-page',
  canViewUsersPage: 'can-view-users-page',
  canViewJobsPage: 'can-view-jobs-page',
  canViewWorkersPage: 'can-view-workers-page',
  canViewCorpSiteWorkersListPage: 'can-view-corp-site-workers-list-page',
  canViewDocumentationsPage: 'can-view-documentations-page',
  canViewVehiclesPage: 'can-view-vehicles-page',
  canViewAlertsPage: 'can-view-alerts-page',
  canViewStaffingDocumentAlertListPage: 'can-view-staffing-document-alerts-list-page',
  canViewAreaSectionDocumentAlertListPage: 'can-view-area-section-document-alerts-list-page',
  canViewStaffingDocumentationListPage: 'can-view-staffing-documentation-list-page',
  canViewHelpCentersPage: 'can-view-help-centers-page',
  canViewSiteWorkersPage: 'can-view-site-workers-site-page',
  canViewPersonnelPage: 'can-view-personnel-page',
  canViewAreaSectionJobListPage: 'can-view-area-section-job-list-page',
  canViewStaffingContractorJobListPage: 'can-view-staffing-contractor-job-list-page',
  canViewWorkerAccessesPage: 'can-view-worker-accesses-page',
  canViewAreaSectionAccessListPage: 'can-view-area-section-access-list-page',
  canViewStaffingContractorAccessListPage: 'can-view-staffing-contractor-access-list-page',
  canViewContractorsPage: 'can-view-contractors-page',
  canViewRegularContractorJobListPage: 'can-view-regular-contractor-job-list-page',
  canViewStoreSectionJobListPage: 'can-view-store-section-job-list-page',
  canViewAreaSectionContractorListPage: 'can-view-area-section-contractor-list-page',
  canViewCorpSiteContractorListPage: 'can-view-corp-site-contractor-list-page',
  canViewStoreSectionContractorListPage: 'can-view-store-section-contractor-list-page',
  canViewAreaSectionContractorFormPage: 'can-view-area-section-contractor-form-page',
  canViewCorpSiteContractorFormPage: 'can-view-corp-site-contractor-form-page',
  canViewRegularContractorAccessListPage: 'can-view-regular-contractor-access-list-page',
  canViewRegularDocumentationListPage: 'can-view-regular-documentation-list-page',
  canViewRegularContractorDashboardPage: 'can-view-regular-contractor-dashboard-page',
  canViewStoreSectionDashboardPage: 'can-view-store-section-dashboard-page',
  canViewCorpSiteContractorUserListPage: 'can-view-corp-site-contractor-user-list-page',
  canViewAreaSectionContractorUserListPage: 'can-view-area-section-contractor-user-list-page',
  canViewAreaSectionContractorDetailPage: 'can-view-area-section-contractor-detail-page',
  canViewCorpSiteContractorDetailPage: 'can-view-corp-site-contractor-detail-page',
  canViewStoreSectionContractorDetailPage: 'can-view-store-section-contractor-detail-page',
  canViewStaffingContractorF30Page: 'can-view-staffing-contractor-f30-page',
  canViewRegularContractorF30Page: 'can-view-regular-contractor-f30-page',
  canViewPaymentOutcomeButton: 'can-view-payment-outcome-button',
  canViewF30Card: 'can-view-f30-card',
  canViewInvoicesPage: 'can-view-invoices-page',
  canViewStaffingContractorJobDetailPage: 'can-view-staffing-contractor-job-detail-page',
  canViewAreaSectionJobDetailPage: 'can-view-area-section-job-detail',
  canViewRegularContractorJobDetailPage: 'can-view-regular-contractor-job-detail',
  canViewStoreSectionJobDetailPage: 'can-view-store-section-job-detail',
  canViewAreaSectionJobFormPage: 'can-view-area-section-job-form-page',
  canViewRegularContractorJobFormPage: 'can-view-regular-contractor-job-form-page',
  canViewAdministratorSectionJobDetailPage: 'can-view-administrator-section-job-detail-page',
  canViewAdministratorSectionJobListPage: 'can-view-administrator-section-job-list-page',
  canViewStoreSectionJobFormPage: 'can-view-store-section-job-form-page',
  canViewStaffingContractorJobFormPage: 'can-view-staffing-contractor-job-form-page',
  canViewStoreSectionContractorFormPage: 'can-view-store-section-contractor-form-page',
  canViewAreaSectionVehiclesPage: 'can-view-area-section-vehicles-page',
  canViewAdminDashboardPage: 'can-view-admin-dashboard-page',
  canViewAdminUserListPage: 'can-view-admin-user-list-page',
  canViewCorpSiteUserListPage: 'can-view-corp-site-user-list-page',
  canViewAreaSectionStoreDetailPage: 'can-view-area-section-store-detail-page',
  canViewAreaSectionUserDetailPage: 'can-view-area-section-user-detail-page',
  canViewCorpSiteUserDetailPage: 'can-view-corp-site-user-detail-page',
  canViewAreaSectionEventListPage: 'can-view-area-section-event-list-page',
  canViewAreaSectionAreaDetailPage: 'can-view-area-section-area-detail-page',
  canViewJobType: 'can-view-job-type',
  canCreateWorkerAnnotations: 'can-create-worker-annotations',
  canApproveDocument: 'can-approve-document',
  canViewAllJobs: 'can-view-all-jobs',
  canViewAreaSectionLiveAccesses: 'can-view-area-section-live-accesses',
  canGenerateManualMarks: 'can-generate-manual-marks',
  canUploadDocuments: 'can-upload-documents',
  canManagePersonnel: 'can-manage-personnel',
  canManageVehicle: 'can-manage-vehicle',
  canCreateAreaSectionJobs: 'can-create-area-section-jobs',
  canCreateContractors: 'can-create-contractors',
  canAssociateContractors: 'can-associate-contractors',
  canManageContractors: 'can-manage-contractors',
  canViewAdministratorSectionAccessListPage: 'can-view-administrator-section-access-list-page',
  canViewAddPersonnelButton: 'can-view-add-personnel-button',
  canViewStatusPersonnelButton: 'can-view-status-personnel-button',
  canViewEditPersonnelButton: 'can-view-edit-personnel-button',
  canViewAdministratorSectionContractorListPage: 'can-view-administrator-section-contractor-list-page',
  canViewReviewJobButton: 'can-view-review-job-button',
  canViewAssociationsTab: 'can-view-associations-tab',
  canViewGeneralJobDetailInput: 'can-view-general-job-detail-input',
  canViewGeneralMessageJobDetailInput: 'can-view-general-message-job-detail-input',
  canViewGeneralJobDetail: 'can-view-general-job-detail',
  canViewAddDocumentButton: 'can-view-add-document-button',
  canViewMultipleLoadButton: 'can-view-multiple-load-button',
  canViewMassiveLoadButton: 'can-view-massive-load-button',
  canViewAdministratorSectionDashboardPage: 'can-view-administrator-section-dashboard-page',
  canViewAdministratorSectionAreaDetailPage: 'can-view-administrator-section-area-detail-page',
  canViewAdministratorSectionUserListPage: 'can-view-administrator-section-user-list-page',
  canManageWorkers: 'can-manage-workers',
  canManageMutual: 'can-manage-mutual',
  canViewAdministratorSectionSettingDetailPage: 'can-view-administrator-section-setting-detail-page',
  canViewCorpSiteSettingDetailPage: 'can-view-corp-site-setting-detail-page',
  canLinkSitesToAnnotation: 'can-link-sites-to-annotation',
  canFilterWorkersAllFields: 'can-filter-workers-all-fields',
  canViewCorpWorkerDetailTabs: 'can-view-corp-worker-detail-tabs',

  // Note: Spanish is used here because, the below permissions are directly generated from the backend.
  canViewAreaSectionContratistasSubcontratoPage: 'can-view-area-section-contratistas-subcontrato-page',
  canViewAreaSectionTiendaPage: 'can-view-area-section-tienda-page',
  canViewAreaSectionAreaPage: 'can-view-area-section-area-page',
  canFilterAllFields: 'can-filter-all-fields',
};

export const PERMISSIONS = {
  [ROLES.staffingContractor]: [
    SCOPES.canViewStaffingContractorDashboardPage,
    SCOPES.canViewAccountPage,
    SCOPES.canViewJobsPage,
    SCOPES.canViewWorkersPage,
    SCOPES.canViewDocumentationsPage,
    SCOPES.canViewVehiclesPage,
    SCOPES.canViewStaffingDocumentAlertListPage,
    SCOPES.canViewHelpCentersPage,
    SCOPES.canViewAlertsPage,
    SCOPES.canViewWorkerAccessesPage,
    SCOPES.canViewStaffingContractorAccessListPage,
    SCOPES.canViewStaffingContractorJobListPage,
    SCOPES.canViewStaffingDocumentationListPage,
    SCOPES.canViewStaffingContractorJobDetailPage,
    SCOPES.canViewStaffingContractorJobFormPage,
    SCOPES.canRestoreVehicles,
    SCOPES.canViewAddPersonnelButton,
    SCOPES.canViewStatusPersonnelButton,
    SCOPES.canViewEditPersonnelButton,
    SCOPES.canViewGeneralJobDetail,
    SCOPES.canViewAddDocumentButton,
    SCOPES.canViewMultipleLoadButton,
    SCOPES.canViewMassiveLoadButton,
    SCOPES.canFilterAllFields,
  ],
  [ROLES.areaSection]: [
    SCOPES.canViewAreaSectionDashboardPage,
    SCOPES.canViewAccountPage,
    SCOPES.canViewSiteWorkersPage,
    SCOPES.canViewAreaSectionJobListPage,
    SCOPES.canViewJobsPage,
    SCOPES.canViewAreaSectionDocumentAlertListPage,
    SCOPES.canViewAreaSectionAccessListPage,
    SCOPES.canViewContractorsPage,
    SCOPES.canViewAreaSectionContractorListPage,
    SCOPES.canViewAreaSectionContractorFormPage,
    SCOPES.canViewHelpCentersPage,
    SCOPES.canViewAreaSectionContractorUserListPage,
    SCOPES.canViewAreaSectionContractorDetailPage,
    SCOPES.canViewAreaSectionJobDetailPage,
    SCOPES.canViewAreaSectionJobFormPage,
    SCOPES.canRegisterVehicles,
    SCOPES.canEditVehicles,
    SCOPES.canDeleteVehicles,
    SCOPES.canViewAreaSectionStoreDetailPage,
    SCOPES.canViewAreaSectionUserDetailPage,
    SCOPES.canViewAreaSectionAreaDetailPage,
    SCOPES.canRestoreVehicles,
    SCOPES.canViewAddPersonnelButton,
    SCOPES.canViewEditPersonnelButton,
    SCOPES.canViewReviewJobButton,
    SCOPES.canViewGeneralJobDetailInput,
    SCOPES.canViewGeneralMessageJobDetailInput,
    SCOPES.canViewAddDocumentButton,
    SCOPES.canViewMultipleLoadButton,
    SCOPES.canViewMassiveLoadButton,
    SCOPES.canManageWorkers,
    SCOPES.canFilterAllFields,
  ],
  [ROLES.corpSite]: [
    SCOPES.canCreateJobs,
    SCOPES.canViewSettingsPage,
    SCOPES.canViewUsersPage,
    SCOPES.canViewContractorsPage,
    SCOPES.canViewCorpSiteContractorListPage,
    SCOPES.canViewCorpSiteContractorFormPage,
    SCOPES.canViewCorpSiteContractorUserListPage,
    SCOPES.canViewCorpSiteContractorDetailPage,
    SCOPES.canViewCorpSiteUserListPage,
    SCOPES.canViewCorpSiteUserDetailPage,
    SCOPES.canCreateContractors,
    SCOPES.canViewCorpSiteSettingDetailPage,
    SCOPES.canViewCorpSiteWorkersListPage,
    SCOPES.canLinkSitesToAnnotation,
    SCOPES.canFilterWorkersAllFields,
    SCOPES.canViewCorpSiteSettingDetailPage,
    SCOPES.canViewCorpWorkerDetailTabs,
  ],
  [ROLES.administratorSection]: [
    SCOPES.canCreateJobs,
    SCOPES.canViewSiteWorkersPage,
    SCOPES.canViewUsersPage,
    SCOPES.canViewWorkerAccessesPage,
    SCOPES.canViewAdministratorSectionAccessListPage,
    SCOPES.canViewContractorsPage,
    SCOPES.canViewJobsPage,
    SCOPES.canViewAdministratorSectionJobDetailPage,
    SCOPES.canViewAdministratorSectionJobListPage,
    SCOPES.canCreateContractors,
    SCOPES.canViewPersonnelPage,
    SCOPES.canViewPersonnelPage,
    SCOPES.canViewAreaSectionAreaPage,
    SCOPES.canViewAdministratorSectionContractorListPage,
    SCOPES.canViewAreaSectionContractorDetailPage,
    SCOPES.canViewAreaSectionContractorFormPage,
    SCOPES.canManagePersonnel,
    SCOPES.canManageContractors,
    SCOPES.canViewAssociationsTab,
    SCOPES.canViewAreaSectionVehiclesPage,
    SCOPES.canViewAreaSectionUserDetailPage,
    SCOPES.canCreateWorkerAnnotations,
    SCOPES.canViewAdministratorSectionDashboardPage,
    SCOPES.canViewAdministratorSectionAreaDetailPage,
    SCOPES.canViewAdministratorSectionUserListPage,
    SCOPES.canViewGeneralJobDetailInput,
    SCOPES.canManageWorkers,
    SCOPES.canViewSettingsPage,
    SCOPES.canViewAdministratorSectionSettingDetailPage,
    SCOPES.canViewAreaSectionStoreDetailPage,
    SCOPES.canFilterAllFields,
  ],
  [ROLES.regularContractor]: [
    SCOPES.canViewAccountPage,
    SCOPES.canViewHelpCentersPage,
    SCOPES.canViewWorkerAccessesPage,
    SCOPES.canViewRegularContractorAccessListPage,
    SCOPES.canViewRegularDocumentationListPage,
    SCOPES.canViewRegularContractorDashboardPage,
    SCOPES.canViewRegularContractorJobListPage,
    SCOPES.canViewJobsPage,
    SCOPES.canViewRegularContractorJobFormPage,
    SCOPES.canViewRegularContractorJobDetailPage,
    SCOPES.canViewAddPersonnelButton,
    SCOPES.canViewStatusPersonnelButton,
    SCOPES.canViewEditPersonnelButton,
    SCOPES.canViewGeneralJobDetailInput,
    SCOPES.canViewGeneralMessageJobDetailInput,
    SCOPES.canViewAddDocumentButton,
    SCOPES.canViewMultipleLoadButton,
    SCOPES.canViewMassiveLoadButton,
    SCOPES.canFilterAllFields,
  ],
  [ROLES.storeSection]: [
    SCOPES.canViewJobsPage,
    SCOPES.canViewAccountPage,
    SCOPES.canViewStoreSectionDashboardPage,
    SCOPES.canViewHelpCentersPage,
    SCOPES.canViewContractorsPage,
    SCOPES.canViewStoreSectionContractorListPage,
    SCOPES.canViewContractorsPage,
    SCOPES.canViewStoreSectionContractorDetailPage,
    SCOPES.canViewStoreSectionJobDetailPage,
    SCOPES.canViewJobsPage,
    SCOPES.canViewStoreSectionJobListPage,
    SCOPES.canViewStoreSectionJobFormPage,
    SCOPES.canViewStoreSectionJobDetailPage,
    SCOPES.canViewStoreSectionContractorFormPage,
    SCOPES.canViewAddPersonnelButton,
    SCOPES.canViewStatusPersonnelButton,
    SCOPES.canViewEditPersonnelButton,
    SCOPES.canViewGeneralJobDetailInput,
    SCOPES.canViewGeneralMessageJobDetailInput,
    SCOPES.canViewAddDocumentButton,
    SCOPES.canViewMultipleLoadButton,
    SCOPES.canViewMassiveLoadButton,
    SCOPES.canFilterAllFields,
  ],
  [ROLES.admin]: [
    SCOPES.canViewUsersPage,
    SCOPES.canViewAdminDashboardPage,
    SCOPES.canViewAdminUserListPage,
    SCOPES.canCreateContractors,
    SCOPES.canViewPersonnelPage,
    SCOPES.canFilterAllFields,
  ],
};
